module.exports = __webpack_public_path__ + "static/media/Trein.4c0669e8.mp3";